var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 fl-x-res"},[_vm._m(0),_c('div',{staticClass:"ml-3 text-center-res"},[_c('p',{staticClass:"font-weight-bold mb-2"},[_vm._v(_vm._s(_vm.heading))]),_c('p',{staticClass:"d-sm-none"},[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-2 border-rounded bg-4 text-center fl-x-cc mb-3 mb-lg-0"},[_c('i',{staticClass:"fa fa-gears"})])
}]

export { render, staticRenderFns }